import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import {
  ContentHeader,
  ContentTitle,
  ContentBody
} from 'components/Content'
import KanBoIcon from 'components/KanBoIcon'
import RelativeDate from 'components/RelativeDate'
import User from 'routes/Board/User'
import { convertFromToUser } from 'utils/users'
import * as CardStatusRoles from 'const/CardStatusRoles'
import classes from './Completed.module.scss'

export class Completed extends React.Component {
  static propTypes = {
    status: PropTypes.object,
    changeDate: PropTypes.number,
    changedBy: PropTypes.string,
  }

  renderCompletedDate = ({ dateMoment, nowMoment }) => {
    return (
      <span
        title={dateMoment.format('LLLL')}
      >
        <span className={classes.icon}>
          <KanBoIcon name='kanbo-16-due-date' style={{ fontSize: 16 }} />
        </span>
        {dateMoment.from(nowMoment)}
      </span>
    )
  }

  render () {
    const {
      status,
      changeDate,
      changedBy
    } = this.props

    if (!status || status.role !== CardStatusRoles.COMPLETED) return null

    const user = changedBy && convertFromToUser(changedBy)

    const showUser = user && user.type === 'USER'
    const showDate = changeDate > 0

    const hasContent = showUser || showDate

    return (
      <Content>
        <ContentHeader>
          <ElementContentIcon>
            <KanBoIcon className='text-success' name='kanbo-24-status-big-completed-inactive' />
          </ElementContentIcon>
          <ContentTitle className='text-success'>
            <FormattedMessage id='CARD_COMPLETED' />
          </ContentTitle>
        </ContentHeader>
        {hasContent &&
          <ContentBody className={classes.infoWrapper}>
            {showUser &&
              <span>
                <User
                  avatar
                  id={user.id}
                  size={16}
                  className={classes.icon}
                />
                <User
                  text
                  id={user.id}
                />
              </span>
            }
            {showDate &&
              <RelativeDate pastOnly timestamp={changeDate}>
                {this.renderCompletedDate}
              </RelativeDate>
            }
          </ContentBody>
        }
      </Content>
    )
  }
}

export default Completed
